import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { GlobalContext } from "store/globalContext";

export const useEditItem = ({ defaultFormData, handleClose }) => {
  const { openConfirmationWithCallback } = useContext(GlobalContext);
  const [previousData, setPreviousData] = useState(defaultFormData);

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    watch,
    formState: { isDirty },
  } = useForm({
    defaultValues: defaultFormData,
  });

  const closeAndReset = () => {
    reset(defaultFormData);
    handleClose();
  };

  const handleCancel = () => {
    if (!isDirty) {
      closeAndReset();
      return;
    }

    openConfirmationWithCallback({
      title: "Please confirm",
      message: "All changes will be lost. Proceed?",
      callbackFn: () => {
        closeAndReset();
      },
      buttonLabels: ["No", "Yes"],
    });
  };

  return {
    previousData,
    setPreviousData,
    control,
    handleSubmit,
    getValues,
    reset,
    watch,
    isDirty,
    handleCancel,
  };
};
